import PropTypes from 'prop-types';
import { Component } from 'react';

export default class BeforeDisplayErrorBoundary extends Component {
    static defaultProps = {
        children: null,
        fallbackMessageNode: null,
    };

    static propTypes = {
        children: PropTypes.node,
        fallbackMessageNode: PropTypes.node,
        isMessageModifiedBeforeDisplay: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error) {
        this._handleError(error);
    }

    _handleError = (error) => {
        if (this.props.isMessageModifiedBeforeDisplay) {
            console.error('An error occurred during `beforeDisplay` processing.');
            this.setState({ hasError: true });
        } else {
            throw error;
        }
    };

    render() {
        if (this.state.hasError) {
            return this.props.fallbackMessageNode;
        }

        return this.props.children;
    }
}
